import React from 'react';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import {
    Priorities,
    HandleChangeSelectType,
    PriorityLevels,
    QCJobItemModified,
} from '../../QCManagerTypes';
import './PriorityQCModal.scss';
import {getAdditionalInfo, getSelectedJobsNames} from '../AssignQCModal/AssignDialog';

export interface PrioritySingleQCModalProps {
    open: boolean;
    title?: string;
    data?: QCJobItemModified[],
    checkedItems?: number[];
    getChecked: (value: number) => boolean;
    handlePriorityClose: () => void;
    handlePriorityChange?: () => void;
    handlePrioritySingleChange?: () => void;
    handleSelectChangePriority: HandleChangeSelectType;
    getCurrentPriorityLevel?: (priority: number) => PriorityLevels;
    priority?: number;
}

export default function PriorityQCModal(props: PrioritySingleQCModalProps) {
    const {
        open,
        title,
        data = [],
        checkedItems = [],
        getChecked,
        handlePriorityClose,
        handlePriorityChange,
        handlePrioritySingleChange,
        handleSelectChangePriority,
        getCurrentPriorityLevel,
        priority = 3,
    } = props;
    
    const selectedItemsLength = checkedItems.length;
    const tooltipTitle = getSelectedJobsNames(data, checkedItems);
    const additionalInfo = getAdditionalInfo(selectedItemsLength, tooltipTitle, undefined);
    
    return (
        <>
            <Dialog
                className="modal"
                onClose={handlePriorityClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <div className="modal__title">
                    <p>Set priority</p>
                    <IconButton
                        aria-label="close"
                        onClick={handlePriorityClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <MuiDialogContent className="modal__content">
                    <div className="modal__item">
                        Item: <span>{title || additionalInfo}</span>
                    </div>
                    <div className="modal__prio">
                        Current prio: <p>{getCurrentPriorityLevel ? getCurrentPriorityLevel(priority) : '- -'}</p>
                    </div>
                    <div className="modal__radio-buttons">
                        <div className="modal__radio-buttons-item">
                            <Radio
                                checked={getChecked(Priorities.Highest)}
                                value={Priorities.Highest}
                                onChange={handleSelectChangePriority}
                            />
                            {PriorityLevels.Highest}
                        </div>
                        <div className="modal__radio-buttons-item">
                            <Radio
                                checked={getChecked(Priorities.High)}
                                value={Priorities.High}
                                onChange={handleSelectChangePriority}
                            />
                            {PriorityLevels.High}
                        </div>
                        <div className="modal__radio-buttons-item">
                            <Radio
                                checked={getChecked(Priorities.Medium)}
                                value={Priorities.Medium}
                                onChange={handleSelectChangePriority}
                            />
                            {PriorityLevels.Medium}
                        </div>
                        <div className="modal__radio-buttons-item">
                            <Radio
                                checked={getChecked(Priorities.Low)}
                                value={Priorities.Low}
                                onChange={handleSelectChangePriority}
                            />
                            {PriorityLevels.Low}
                        </div>
                        <div className="modal__radio-buttons-item">
                            <Radio
                                checked={getChecked(Priorities.Lowest)}
                                value={Priorities.Lowest}
                                onChange={handleSelectChangePriority}
                            />
                            {PriorityLevels.Lowest}
                        </div>
                    </div>
                </MuiDialogContent>
                <div className="modal__action-buttons">
                    <Button
                        onClick={handlePriorityClose}
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button
                        className="modal__action-buttons__save"
                        onClick={title ? handlePrioritySingleChange : handlePriorityChange}
                    >
                        Save
                    </Button>
                </div>
            </Dialog>
        </>
    );
}
